/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Dark_Moose_GlowInputs */

const en_bold_dark_moose_glow = /** @type {(inputs: Bold_Dark_Moose_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary color`)
};

const de_bold_dark_moose_glow = /** @type {(inputs: Bold_Dark_Moose_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primärfarbe`)
};

/**
* | output |
* | --- |
* | "Primary color" |
*
* @param {Bold_Dark_Moose_GlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_dark_moose_glow = /** @type {((inputs?: Bold_Dark_Moose_GlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Dark_Moose_GlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_dark_moose_glow(inputs)
	return de_bold_dark_moose_glow(inputs)
});